var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRobinhood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 450,
    height: 450,
    viewBox: "0 0 450 450",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 450,
    height: 450,
    fill: "#D1FE40"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M245.361 173.729H207.352C205.977 173.729 204.814 174.273 203.851 175.461L176.594 208.866C172.594 213.815 171.593 218.393 171.593 224.95V259.098C162.716 283.718 157.09 300.421 152.964 315.515C152.714 316.48 153.089 317 153.964 317H158.09C158.84 317 159.59 316.629 159.84 316.01C190.973 237.57 224.856 198.721 246.111 175.461C246.987 174.471 246.612 173.729 245.361 173.729Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M246.486 135.251C243.936 136.228 241.485 137.886 240.36 138.839C229.107 148.365 221.605 155.912 214.478 163.336C213.603 164.202 213.978 165.068 215.229 165.068H257.364C261.24 165.068 263.49 167.295 263.49 171.13V218.145C263.49 219.382 264.491 219.754 265.241 218.64L290.622 185.853C294.748 180.533 295.998 178.925 297.124 171.502C298.624 160.614 297.749 143.911 291.122 136.983C285.246 130.797 258.739 130.549 246.486 135.251Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M252.862 183.132C226.731 211.959 206.351 242.271 187.472 278.77C186.996 279.685 187.597 280.502 188.722 280.13L227.731 268.253C232.132 266.917 234.608 265.16 236.734 261.696L254.113 233.363C254.488 232.621 254.613 231.755 254.613 231.136V183.874C254.613 182.637 253.738 182.142 252.862 183.132Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobinhood);
export default __webpack_public_path__ + "static/media/robinhood.ae43e904179bc90028d853f24bafabb1.svg";
export { ForwardRef as ReactComponent };